import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { api } from '../../../models/api-url.model';
import { Order } from '../../../models/order.model';
import { ApiService } from '../api';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private readonly apiService = inject(ApiService);

  getOrders(): Observable<Order[]> {
    return this.apiService.get(api.ordersURL);
  }

  getOpenOrdersTotal(): Observable<number> {
    return this.apiService.get(`${api.ordersURL}/open_total`);
  }

  createOrder(orderData: Partial<Order>): Observable<Order> {
    return this.apiService.post(`${api.ordersURL}`, orderData);
  }

  getLastUpdated(): Promise<string> {
    return Promise.resolve('--');
  }
}
